import React from "react"
import { Link } from "react-router-dom"

const AcceptableUse = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8">
          <Link to="/users/sign_up" className="text-indigo-600 hover:text-indigo-500">
            &larr; Back to Sign Up
          </Link>
        </div>

        <div className="bg-white shadow rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Acceptable Use Policy</h1>
          <p className="text-sm text-gray-500 mb-8">Last updated: January 30, 2026</p>

          <div className="prose prose-indigo max-w-none space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-3">1. Introduction</h2>
              <p>
                This Acceptable Use Policy ("Policy") governs your use of Heartily.app ("Service") operated by
                Hosting Playground Inc. This Policy is designed to protect the Service, our users, and third parties
                from harmful or illegal activities.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-3">2. Prohibited Activities</h2>
              <p>
                You may not use the Service to:
              </p>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">2.1 Illegal Activities</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Violate any applicable local, state, national, or international law</li>
                <li>Engage in fraud, identity theft, or other deceptive practices</li>
                <li>Infringe on the intellectual property rights of others</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">2.2 Harmful Content</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Upload or transmit viruses, malware, or other malicious code</li>
                <li>Distribute spam, phishing content, or unsolicited communications</li>
                <li>Post content that is defamatory, obscene, or threatening</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">2.3 Security Violations</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Attempt to gain unauthorized access to any systems or networks</li>
                <li>Probe, scan, or test the vulnerability of the Service</li>
                <li>Interfere with or disrupt the integrity or performance of the Service</li>
                <li>Circumvent any security or authentication measures</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">2.4 Abuse of Service</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Create multiple accounts for deceptive or abusive purposes</li>
                <li>Share your account credentials with others</li>
                <li>Use automated systems or bots without authorization</li>
                <li>Scrape or harvest data from the Service</li>
                <li>Resell or redistribute the Service without authorization</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">2.5 Academic Integrity</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Use the Service to facilitate cheating or academic dishonesty</li>
                <li>Share assignment answers or solutions inappropriately</li>
                <li>Misrepresent your academic work or progress</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-3">3. Resource Usage</h2>
              <p>
                You agree to use the Service responsibly and not to:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Make excessive API requests that could impact service performance</li>
                <li>Store or transmit excessively large amounts of data</li>
                <li>Use the Service in a manner that consumes disproportionate resources</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-3">4. Canvas Integration Guidelines</h2>
              <p>
                When using the Canvas LMS integration, you must:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Only use access tokens that you are authorized to use</li>
                <li>Comply with your educational institution's policies regarding third-party integrations</li>
                <li>Not use the integration to access data belonging to others without permission</li>
                <li>Keep your Canvas access tokens secure and confidential</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-3">5. Reporting Violations</h2>
              <p>
                If you become aware of any violation of this Policy, please report it to us immediately at:
              </p>
              <p className="mt-2">
                Email: abuse@heartily.app
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-3">6. Enforcement</h2>
              <p>
                Violations of this Policy may result in:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Warning or temporary suspension of your account</li>
                <li>Permanent termination of your account</li>
                <li>Reporting to law enforcement authorities</li>
                <li>Legal action to recover damages</li>
              </ul>
              <p className="mt-3">
                We reserve the right to investigate and take appropriate action against anyone who violates this Policy,
                at our sole discretion.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-3">7. Changes to This Policy</h2>
              <p>
                We may update this Acceptable Use Policy from time to time. We will notify you of any changes by
                posting the new Policy on this page and updating the "Last updated" date.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-3">8. Contact Us</h2>
              <p>
                If you have questions about this Acceptable Use Policy, please contact us at:
              </p>
              <p className="mt-2">
                <strong>Hosting Playground Inc</strong><br />
                Email: legal@heartily.app
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AcceptableUse
